import * as React from 'react';
import { useState } from 'react';

import { Button } from '@/components/ui/button';

import { CalendlyModal } from '@/lib/calendly/calendly.modal';

export function BookDemoButton() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        size="lg"
        variant="glowing"
        className="uppercase w-full md:w-fit flex-shrink-0"
        onClick={() => setOpen(true)}
      >
        Book a Demo
      </Button>
      <CalendlyModal open={open} setOpen={setOpen} />
    </>
  );
}
